module.exports = __webpack_public_path__ + "img/gamifinnopoly_blue.ced415b3.png";